import { buildCollection, buildProperty } from "@firecms/core";

export type LimitSettings = {
    dailyTotalLimit?: number;
    dailyImageLimit?: number;
    dailyPdfLimit?: number;
    dailyYoutubeLimit?: number;
    dailyQuizLimit?: number;
    dailyVideoLimit?: number;
    freeTrialLimit?: number;
};

/**
 * settings/limits — app + CF dinamik kotalar.
 * Sadece düzenleme; yeni belge / silme yok.
 */
export const settingsCollection = buildCollection<LimitSettings>({
    id: "settings",
    name: "Ayarlar",
    singularName: "Ayar",
    path: "settings",
    group: "Ayarlar",
    icon: "tune",
    description: "Günlük ve ücretsiz deneme tavanları (settings/limits)",
    permissions: {
        read: true,
        create: false,
        edit: true,
        delete: false,
    },
    properties: {
        dailyTotalLimit: buildProperty({
            name: "Günlük toplam",
            dataType: "number",
            validation: {
                required: true,
                min: 0,
                integer: true,
            },
        }),
        dailyImageLimit: buildProperty({
            name: "Günlük görsel",
            dataType: "number",
            validation: {
                required: true,
                min: 0,
                integer: true,
            },
        }),
        dailyPdfLimit: buildProperty({
            name: "Günlük PDF",
            dataType: "number",
            validation: {
                required: true,
                min: 0,
                integer: true,
            },
        }),
        dailyYoutubeLimit: buildProperty({
            name: "Günlük YouTube",
            dataType: "number",
            validation: {
                required: true,
                min: 0,
                integer: true,
            },
        }),
        dailyQuizLimit: buildProperty({
            name: "Günlük quiz",
            dataType: "number",
            validation: {
                required: true,
                min: 0,
                integer: true,
            },
        }),
        dailyVideoLimit: buildProperty({
            name: "Günlük video çözüm",
            dataType: "number",
            validation: {
                required: true,
                min: 0,
                integer: true,
            },
        }),
        freeTrialLimit: buildProperty({
            name: "Ücretsiz deneme hakkı",
            dataType: "number",
            validation: {
                required: true,
                min: 0,
                integer: true,
            },
        }),
    },
});
